import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "../store/index";
import { isLoggedInUserAdmin, getUserData } from "../plugins/handlers";

import {
  User_InitiatePasswordReset,
  User_ResetPassword,
} from "../components/pages/user-auth/user-auth.routing";
import {
  User_SetSecurityQuestion,
  User_UpdateUser,
  User_UpdateUserSecurityData,
  User_UserSkills,
  User_Settings,
} from "../components/pages/user-profile/user-profile.routing";

import {
  User_AllPaymentsInProject,
  User_AppliableProjects,
  User_CancelledProjects,
  User_DraftProjects,
  User_ProjectMedia,
  User_RunningProjects,
  User_UsersAssignedtoProject,
  User_CreateProject,
  User_VerifyTransaction,
  User_ShowProject,
  User_ViewProject,
  User_AllProjects,
  User_PublishedProjects,
  User_CompletedProjects
} from "../components/pages/user-projects/user-projects.routing";

import {
  User_AllApplications,
  User_AssignedApplications,
  User_CompletedApplications
} from "../components/pages/user-applications/user-applications.routing"

import {
  Admin_AllPayments,
  Admin_AllSuccessfulPayments,
} from "../components/pages/admin/admin-payments/admin-payments.routing";

import {
  Admin_AllProjects,
  Admin_CancelledProjects,
  Admin_CompletedProjects,
  Admin_DeletedProjects,
  Admin_DraftProjects,
  Admin_PublishedProjects,
  Admin_StartedProjects,
} from "../components/pages/admin/admin-projects/admin-projects.routing";

import {
  Admin_Tasks,
  Admin_CreateTask,
  Admin_SubTasks,
} from "../components/pages/admin/admin-tasks/admin-tasks.routing";

import { Admin_AllUsers } from "../components/pages/admin/admin-users/admin-users.routing";

// basic user routes
import {
  User_Home,
  User_About,
  User_Contact,
  User_FAQ,
  User_Profile,
  User_Messages,
  // User_Settings,
  User_MyTasks,
  // User_MyProjects,
  User_ProjectDetails,
  User_Earnings,
  User_TaskDetails,
  User_Projects,
  User_Login,
  User_Register,
  User_ForgotPassword,
  User_dashboard,
  Path_NotFound,
  User_SavedJobs,
  User_Reviews,
  User_Payments,
  User_Jobs,
  Admin_Countries,
  Admin_Regions,
  Admin_Users,
  Admin_Projects,
  Admin_Cities,
  Admin_Regions_In_Country,
} from "../router/basicUserRoutes";

// admin user routes
// import { Admin_Home, Admin_Users } from '../router/adminRoutes';

import { guardedRoute } from "../router/guardedRoute";

Vue.use(VueRouter);

const routes = [
  // user auth
  User_ResetPassword,
  User_InitiatePasswordReset,

  // user profile
  User_SetSecurityQuestion,
  User_UpdateUser,
  User_UpdateUserSecurityData,
  User_UserSkills,

  // user projects
  User_AllPaymentsInProject,
  User_AppliableProjects,
  User_CancelledProjects,
  User_DraftProjects,
  User_ProjectMedia,
  User_RunningProjects,
  User_UsersAssignedtoProject,
  User_CreateProject,
  User_VerifyTransaction,
  User_ShowProject,
  User_ViewProject,
  User_PublishedProjects,
  User_AllProjects,
  User_CompletedProjects,

  // basic user routes
  User_Home,
  User_About,
  User_Contact,
  User_FAQ,
  User_Profile,
  User_Messages,
  User_Settings,
  User_MyTasks,
  // User_MyProjects,
  User_ProjectDetails,
  User_Earnings,
  User_TaskDetails,
  User_Projects,
  User_Login,
  User_Register,
  User_ForgotPassword,
  User_dashboard,
  Path_NotFound,
  User_SavedJobs,
  User_Reviews,
  User_Payments,
  User_Jobs,

  //User_Applications
  User_AllApplications,
  User_AssignedApplications,
  User_CompletedApplications,

  // admin projects
  Admin_AllProjects,
  Admin_CancelledProjects,
  Admin_CompletedProjects,
  Admin_DeletedProjects,
  Admin_DraftProjects,
  Admin_PublishedProjects,
  Admin_StartedProjects,

  // admin payments
  Admin_AllPayments,
  Admin_AllSuccessfulPayments,

  // admin tasks
  Admin_Tasks,
  Admin_CreateTask,
  Admin_SubTasks,


  // admin users
  Admin_AllUsers,

  // admin user routes
  // Admin_Home,
  // Admin_Users,
  //admin locations
  Admin_Countries,
  Admin_Regions,
  Admin_Users,
  Admin_Projects,
  Admin_Cities,
  Admin_Regions_In_Country,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let isLoggedIn = !!store.state.token;
  let isAdminPath = to.path.substring(1, 6) === "admin";

  let isGuardedRoute = guardedRoute.includes(to.name) || isAdminPath;
  if (isGuardedRoute && !isLoggedIn) localStorage.setItem("from", from.path);

  if (isAdminPath && isLoggedInUserAdmin() === false) next({ name: "Home" });

  if (guardedRoute.includes(to.name) && !isLoggedIn) {
    next({ name: "Login" });
  } else {
    getUserData();
    next();
  }
});

export default router;
